import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { InputController } from '@/components/form/controllers/input-controller';
import { cn } from '@/lib/utils';

import type { EstatesFiltersSchemaType } from '../schemas';
import {
  activeFilterFieldClassName,
  activeFilterInputClassName,
  hasActiveFilterValue,
} from './estate-filter-active-field';

export const EstateFilterPrices = () => {
  const { t } = useTranslation();

  const methods = useFormContext<EstatesFiltersSchemaType>();
  const buyingPriceMin = methods.watch('buyingPrices.min');
  const buyingPriceMax = methods.watch('buyingPrices.max');
  const minLivingArea = methods.watch('minLivingArea');
  const maxLivingArea = methods.watch('maxLivingArea');

  return (
    <fieldset className="mb-6 space-y-6">
      <div>
        <p className="mb-3 text-sm font-semibold text-[#2F3A4A]">
          {t('priceRange', 'Price Range (€)')}
        </p>
        <div className="grid grid-cols-2 gap-4">
          <div className={cn(hasActiveFilterValue(buyingPriceMin) && activeFilterFieldClassName)}>
            <p className="mb-1 text-xs font-medium text-[#68778E]">{t('min', 'Min')}</p>
            <InputController
              methods={methods}
              name="buyingPrices.min"
              type="number"
              size="sm"
              min={0}
              className={cn(
                '!border-border text-text-secondary placeholder:text-text-secondary hover:!border-primary-light focus-visible:!border-primary-light',
                hasActiveFilterValue(buyingPriceMin) && activeFilterInputClassName
              )}
              placeholder="0"
            />
          </div>
          <div className={cn(hasActiveFilterValue(buyingPriceMax) && activeFilterFieldClassName)}>
            <p className="mb-1 text-xs font-medium text-[#68778E]">{t('max', 'Max')}</p>
            <InputController
              methods={methods}
              name="buyingPrices.max"
              type="number"
              size="sm"
              min={0}
              className={cn(
                '!border-border text-text-secondary placeholder:text-text-secondary hover:!border-primary-light focus-visible:!border-primary-light',
                hasActiveFilterValue(buyingPriceMax) && activeFilterInputClassName
              )}
              placeholder="1,000,000"
            />
          </div>
        </div>
      </div>

      <div className="border-t border-[hsl(214.3_31.8%_91.4%)]" />

      <div>
        <p className="mb-3 text-sm font-semibold text-[#2F3A4A]">
          {t('areaRange', 'Area Range (m²)')}
        </p>
        <div className="grid grid-cols-2 gap-4">
          <div className={cn(hasActiveFilterValue(minLivingArea) && activeFilterFieldClassName)}>
            <p className="mb-1 text-xs font-medium text-[#68778E]">{t('min', 'Min')}</p>
            <InputController
              methods={methods}
              name="minLivingArea"
              type="number"
              size="sm"
              min={0}
              className={cn(
                '!border-border text-text-secondary placeholder:text-text-secondary hover:!border-primary-light focus-visible:!border-primary-light',
                hasActiveFilterValue(minLivingArea) && activeFilterInputClassName
              )}
              placeholder="0"
            />
          </div>
          <div className={cn(hasActiveFilterValue(maxLivingArea) && activeFilterFieldClassName)}>
            <p className="mb-1 text-xs font-medium text-[#68778E]">{t('max', 'Max')}</p>
            <InputController
              methods={methods}
              name="maxLivingArea"
              type="number"
              size="sm"
              min={0}
              className={cn(
                '!border-border text-text-secondary placeholder:text-text-secondary hover:!border-primary-light focus-visible:!border-primary-light',
                hasActiveFilterValue(maxLivingArea) && activeFilterInputClassName
              )}
              placeholder="500"
            />
          </div>
        </div>
      </div>
    </fieldset>
  );
};
